export const styleData1 = [
  { key: 'text', label: '文本' },
  { key: 'fontSize', label: '字体大小' },
  { key: 'backgroundColor', label: '背景颜色' },
  { key: 'color', label: '字体颜色' },
  { key: 'frameColor', label: '边框颜色' },
  { key: 'lineColor', label: '线条颜色' },
  // { key: 'frameWeight', label: '边框线宽' },
  { key: 'colAligns', label: '列对齐' },
  { key: 'tableHeadFontSize', label: '表头字大小' },
  { key: 'tableBodyFontSize', label: '表体字大小' },
  { key: 'halign', label: '横向对齐' },
  { key: 'valign', label: '纵向对齐' },
  { key: 'inMethod', label: '引入方式' },
  { key: 'inSpeed', label: '引入速度' },
  { key: 'outMethod', label: '引出方式' },
  { key: 'outSpeed', label: '引出速度' },
  { key: 'stopMethod', label: '停留方式' },
  { key: 'stopSpeed', label: '停留速度' },
  { key: 'stopTime', label: '停留时间' },
  { key: 'formats', label: '时间格式' },
  { key: 'format', label: '时间格式' },
  { key: 'type', label: '类型' },

  // { key: 'left', label: 'x 坐标' },
  // { key: 'top', label: 'y 坐标' },
  // { key: 'rotate', label: '旋转角度' },
  // { key: 'width', label: '宽' },
  // { key: 'height', label: '高' },
  { key: 'textAlign', label: '左右对齐' },
  { key: 'verticalAlign', label: '上下对齐' }
]

export const styleData = [
  { key: 'left', label: 'x 坐标' },
  { key: 'top', label: 'y 坐标' },
  { key: 'rotate', label: '旋转角度' },
  { key: 'width', label: '宽' },
  { key: 'height', label: '高' },
  { key: 'color', label: '颜色' },
  { key: 'backgroundColor', label: '背景色' },
  { key: 'borderWidth', label: '边框宽度' },
  { key: 'borderStyle', label: '边框风格' },
  { key: 'borderColor', label: '边框颜色' },
  { key: 'borderRadius', label: '边框半径' },
  { key: 'direction', label: '方向' },
  { key: 'fontSize', label: '字体大小' },
  { key: 'fontWeight', label: '字体粗细' },
  { key: 'lineHeight', label: '行高' },
  { key: 'letterSpacing', label: '字间距' },
  { key: 'textAlign', label: '左右对齐' },
  { key: 'verticalAlign', label: '上下对齐' },
  { key: 'opacity', label: '不透明度' }
]

export const styleMap = {
  left: 'x 坐标',
  top: 'y 坐标',
  rotate: '旋转角度',
  width: '宽',
  height: '高',
  color: '颜色',
  backgroundColor: '背景色',
  borderWidth: '边框宽度',
  borderStyle: '边框风格',
  borderColor: '边框颜色',
  borderRadius: '边框半径',
  fontSize: '字体大小',
  fontWeight: '字体粗细',
  lineHeight: '行高',
  letterSpacing: '字间距',
  textAlign: '左右对齐',
  verticalAlign: '上下对齐',
  opacity: '不透明度'
}

export const textAlignOptions = [
  {
    label: '左对齐',
    value: 'left'
  },
  {
    label: '居中',
    value: 'center'
  },
  {
    label: '右对齐',
    value: 'right'
  }
]

export const borderStyleOptions = [
  {
    label: '实线',
    value: 'solid'
  },
  {
    label: '虚线',
    value: 'dashed'
  }
]

export const verticalAlignOptions = [
  {
    label: '上对齐',
    value: 'top'
  },
  {
    label: '居中对齐',
    value: 'middle'
  },
  {
    label: '下对齐',
    value: 'bottom'
  }
]

export const selectKey = ['textAlign', 'borderStyle', 'verticalAlign']

export const optionMap = {
  textAlign: textAlignOptions,
  borderStyle: borderStyleOptions,
  verticalAlign: verticalAlignOptions
}
